import { TableId } from '@/modules/common/enums/table-id.enum.ts';
import { Route } from '@/modules/core/enums/route.enum.ts';

const routeByTableId: Partial<Record<TableId, Route>> = {
  [TableId.Documents]: Route.DocumentPage,
  [TableId.Counterparties]: Route.CounterpartyPage,
};

export class FavoriteRouteUtil {
  static get(tableId: TableId, id: number, commentId?: number) {
    const name = routeByTableId[tableId];
    if (!name) {
      return null;
    }

    return {
      name,
      params: { id },
      ...(commentId !== undefined ? { query: { commentId } } : {}),
    };
  }
}
